import React from 'react';
import AppHeader from '../../../components/AppHeader.tsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';

const CommissionsPage: React.FC = () => {
  const breadcrumb = [{ label: 'Zaměstnanci' }, { label: 'Komise a odměny' }];

  return (
    <div className="h-full flex flex-col">
      <AppHeader title="Komise a odměny" breadcrumb={breadcrumb} />

      <div className="flex-1 overflow-y-auto bg-gray-50">
        <div className="p-6">
          <section className="bg-white rounded-lg shadow-sm p-12 text-center">
            <FontAwesomeIcon icon={faCircleInfo} className="text-gray-400 text-5xl mb-4" />
            <h1 className="text-2xl font-semibold text-gray-900 mb-2">Funkce odstraněna</h1>
            <p className="text-gray-600 max-w-xl mx-auto">
              Modul komisí a odměn byl ve zjednodušené verzi systému odebrán. Pokud potřebujete přehled o tržbách
              jednotlivých pracovníků, použijte prosím statistiky výkonu nebo přehled rezervací.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default CommissionsPage;
